import { type DropdownMenuItem, Typography } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { SelectMetricLabel } from '../components/SelectMetricLabel';
import { FunctionalTestMethod } from './enum';

const metricConfigs = [
  {
    key: Object.keys(FunctionalTestMethod)[0],
    title: 'Rep count entry',
    description: `Select this to enter the rep count. Each rep will equal 1 score. If the rep count
    exceeds the max score, the client's score will be capped at the max score limit.`,
  },
  {
    key: Object.keys(FunctionalTestMethod)[1],
    title: 'Score entry',
    description: `Select this if you want to manually enter the score or if the score is automatically
    calculated based on finish time.`,
  },
  {
    key: Object.keys(FunctionalTestMethod)[2],
    title: 'Time entry',
    description: `Select this to enter time by the stopwatch. This functional test has no score.`,
  },
  {
    key: Object.keys(FunctionalTestMethod)[3],
    title: 'Weight entry',
    description: `Select this to enter weight with kilogram measure. This functional test has no score.`,
  },
];

const createMetricMenuItem = ({
  key,
  title,
  description,
}: (typeof metricConfigs)[number]): DropdownMenuItem => ({
  key,
  label: (
    <SelectMetricLabel
      title={
        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
          {title}
        </Typography>
      }
      description={
        <Typography variant="body-3" color={COLOR_CONFIG['neutral-text']}>
          {description}
        </Typography>
      }
    />
  ),
  isIconTick: false,
});

export const metricMenu: DropdownMenuItem[] = metricConfigs.map(createMetricMenuItem);
